export default __webpack_public_path__ + "static/media/B10.d72641ba.jpg";